"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
var DataField_1;
"use strict";
const core_decorators_1 = require("core-decorators");
const lodash_1 = require("lodash");
const interval_1 = require("./covariate/interval");
let DataField = DataField_1 = class DataField {
    constructor(fieldJson) {
        this.name = fieldJson.name;
        this.interval = fieldJson.interval
            ? new interval_1.Interval(fieldJson.interval)
            : undefined;
    }
    static getUniqueDataFields(dataFields) {
        return lodash_1.uniqWith(dataFields, DataField_1.isSameDataField);
    }
    static isSameDataField(dataFieldOne, dataFieldTwo) {
        return dataFieldOne.name === dataFieldTwo.name;
    }
    static findDataFieldWithName(dataFields, name) {
        return dataFields.find(dataField => {
            return dataField.name === name;
        });
    }
    getDatumForField(data) {
        return data.find(datum => datum.name === this.name);
    }
    isFieldWithName(name) {
        return this.name === name;
    }
};
DataField = DataField_1 = tslib_1.__decorate([
    core_decorators_1.autobind
], DataField);
exports.DataField = DataField;
//# sourceMappingURL=data-field.js.map